import React, { Fragment } from "react";
import { Breadcrumbs } from "../../AbstractElements";
import OnDemandTuitionRequestContainer from "../../Component/OnDemandTuitionRequest";
import useLogoutSession from "../../_helper/LogoutAfterSessionExpiration/useLogoutSession";

const OnDemandTuitionRequest = () => {
  useLogoutSession();
  return (
    <Fragment>
      <Breadcrumbs parent="Bookmarks" />
      <OnDemandTuitionRequestContainer />
    </Fragment>
  );
};
export default OnDemandTuitionRequest;
